// Minimal mustache-style {{variable}} replacement engine. Avoids pulling in
// full mustache dependency — Avatar templates only need flat variable
// substitution, no loops or conditionals.
//
// Unknown variables left as-is, NOT replaced with empty string. This makes
// missing variables visible in output for easier debugging.

const TEMPLATE_PATTERN = /\{\{\s*([a-zA-Z_][a-zA-Z0-9_]*)\s*\}\}/g;

export function renderTemplate(
  source: string,
  variables: Record<string, string | number | undefined>,
): string {
  return source.replace(TEMPLATE_PATTERN, (match, key: string) => {
    const value = variables[key];
    if (value === undefined) return match;
    return String(value);
  });
}

// Extract the variable names referenced by a template — useful for
// scaffolding tests and validating that callers pass every required key.
export function extractVariables(source: string): string[] {
  const found = new Set<string>();
  for (const match of source.matchAll(TEMPLATE_PATTERN)) {
    if (match[1]) found.add(match[1]);
  }
  return Array.from(found).sort();
}
